import React, { useState } from "react";
import "./TermsModal.css";

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (accepted: boolean) => void;
}

const TermsModal: React.FC<TermsModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [accepted, setAccepted] = useState(false);

  if (!isOpen) return null;

  const handleContinue = () => {
    onSubmit(accepted);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content-terms">
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="modal-title">Termos e condições de uso</h2>

        <div className="modal-body">
          <p>
            <strong>IMPORTANTE :</strong> O uso deste website implica na
            concordância com os Termos e Condições de Uso do Site. Você precisa
            ter pelo menos 18 (dezoito) anos para se cadastrar neste Site! Por
            favor, esteja ciente de que nós proibimos quaisquer pessoas de
            promover atividades ilícitas (como prostituição) ou comerciais de
            qualquer tipo em seu perfil ou através de mensagens enviadas pelo
            Site. Se nós soubermos de tais condutas, nos reservamos o direito
            de, entre outras ações, removê-lo e bani-lo permanentemente de nosso
            Site. Se você for uma ACOMPANHANTE ou GAROTA DE PROGRAMA, NÃO SE
            CADASTRE neste website!
          </p>

          {/* <a href="/termos" className="terms-link-full" target="_blank">
            Ler os termos de uso completo
          </a> */}
        </div>

        <div className="modal-actions">
          <div className="terms">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              Aceito os termos de uso
            </label>

            <button
              className="btn-primary"
              onClick={handleContinue}
              disabled={!accepted}
            >
              Continuar cadastro
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
